export default __webpack_public_path__ + "static/media/bal.e7a75ce2.svg";